import React, { useState, useEffect, useMemo } from "react";
import { Container, Col } from "react-bootstrap";
import Masonry from "react-masonry-component";
import InfiniteScroll from 'react-infinite-scroller';
import { Section, Box } from "../../components/Core";
import Select from 'react-select';
import WorkCard from "../../components/WorkCard";

const Works = () => {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [workPage, setWorkPage] = useState(0);

  const [originalItems, setOriginalItems] = useState([]);
  const [categoryItems, setCategoryItems] = useState([]);
  const [activeLink, setActiveLink] = useState("all");

  const options = useMemo(() => [
    { value: 'all', label: 'Все работы' },
    ...categoryItems.map(item => ({
      value: item.code,
      label: item.name
    }))
  ], [categoryItems]);

  const selectedOption = useMemo(() => 
    options.find(opt => opt.value === activeLink) || options[0],
  [options, activeLink]);

  const fetchData = async () => {
    try {
      const response = await fetch("https://tlknitting.com/service/categories");
      const data = await response.json();
      setCategoryItems(data);
    } catch (error) {
      console.error('Categories fetch error:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const filterBy = (cat) => {
    if (cat === activeLink) return; // prevent unnecessary reset
    
    setActiveLink(cat);
    setItems([]);
    setOriginalItems([]);
    setWorkPage(0);
    setHasMore(true);
  };

  const loadWorks = async (page, category) => {
    try {
      const response = await fetch(`https://tlknitting.com/service/works/${category}/${page}`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Works fetch error:', error);
      return [];
    }
  };

  const masonryOptions = {
    transitionDuration: 1000,
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',
      fontWeight: '700',
      textTransform: 'uppercase',
      minHeight: '50px',
      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
      backgroundColor: 'transparent',
      '&:hover': {
        borderColor: 'transparent',
        boxShadow: 'none'
      },
      ':focus-within': {
        borderColor: 'transparent',
        boxShadow: 'none'
      }
    }),
    menu: (provided) => ({
      ...provided,
      width: '100%',
      marginTop: '0',
      borderRadius: 0,
      borderTop: 'none',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }),
    option: (provided, state) => ({
      ...provided,
      fontWeight: '700',
      textTransform: 'uppercase',
      backgroundColor: state.isSelected 
        ? '#007bff' 
        : state.isFocused 
        ? '#f8f9fa' 
        : 'white'
    }),
    singleValue: (provided) => ({
      ...provided,
      fontWeight: '700',
      textTransform: 'uppercase',
      color: 'inherit'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'inherit'
    })
  };

  return (
    <>
      <Section className="position-relative">
        <Container fluid className="px-0">
          <Box mb="1rem" mt="1rem" style={{ paddingLeft: '1.75rem', paddingRight: '1.75rem', width: '100%' }}>
            <Select
              options={options}
              value={selectedOption}
              onChange={(selected) => filterBy(selected?.value || 'all')}
              styles={customStyles}
              isSearchable={false}
              placeholder="Все работы"
              menuPlacement="auto"
              menuPosition="fixed"
            />
          </Box>
        </Container>

        <Container fluid className="px-3 px-md-4">
          <InfiniteScroll
              pageStart={0}
              loadMore={async () => {
                if (isLoading) return;
                const currentPage = workPage + 1;
                setIsLoading(true);
                
                const newData = await loadWorks(currentPage, activeLink);
                
                if (!newData.length) {
                  setHasMore(false);
                  setIsLoading(false);
                  return;
                }
                
                setOriginalItems(prev => [...prev, ...newData]);
                setItems(prev => [...prev, ...newData]);
                setWorkPage(currentPage);
                setIsLoading(false);
              }}
              hasMore={hasMore}
              loader={<div className="col-12 text-center py-4" key={0}>Загрузка...</div>}
          >
              <Masonry options={masonryOptions} className="masonry-grid row">
                  {items.map((item, index) => (
                      <Col lg={3} md={4} sm={6} xs={6} key={`${item.id}-${index}`} className="filtr-item">
                          <WorkCard workItem={item} mb="30px" link={item.url}/>
                      </Col>
                  ))}
              </Masonry>
          </InfiniteScroll>
        </Container>
      </Section>
    </>
  );
};

export default Works;
